import {changeSort} from "~/actions/settingsActions";
import {getTableSettingsIdentifier} from "~/stateGetter";

export const CHANGE_SORT = 'change_sort';
export const CHANGE_PER_PAGE = 'change_per_page';
export const CHANGE_PAGE = 'change_result_page';

export function resultParamsActionCreator(params, dispatch = (a) => a) {
    return {
        changePage: (page) => dispatch({ type: CHANGE_PAGE, page, ...params }),
    }
}